import { Routes, Route, Navigate } from 'react-router-dom'
import RoleRoute from '@BUP/routes/RoleRoute'
import HistoricSociogramPage from '@BUP/pages/Data/sociogram/historicSociogram'
import SociogramPage from '@BUP/pages/Data/sociogram'
import SociogramStudentsList from '@BUP/pages/Data/sociogram/sociogramStudentsList'
import SociogramResultsDashboardPage from '@BUP/pages/Data/sociogram/dashboard/sociogramResultsDashboard'
import SociogramSurveyPage from '@BUP/pages/Data/sociogram/survey/SociogramSurveyPage'
import SociogramPageById from '@BUP/pages/Data/sociogram/survey/[id]'
import { SociogramContextProvider } from '@BUP/contexts/SociogramContext'
import { DashboardSociogramContextProvider } from '@BUP/contexts/DashboardSociogramContext'
import SurveyResultsRecommendationsPage from '@BUP/pages/Data/sociogram/surveyResultsRecommendationsPage'

const SociogramNavigation = () => {
  return (
    <SociogramContextProvider>
      <DashboardSociogramContextProvider>
        <Routes>
          <Route
            path='/'
            element={
              <RoleRoute name='SociogramPage'>
                <SociogramPage />
              </RoleRoute>
            }
          />
          <Route
            path='students-list/:surveyId'
            element={
              <RoleRoute name='SociogramStudentsList'>
                <SociogramStudentsList />
              </RoleRoute>
            }
          />
          <Route
            path='dashboard/:surveyId'
            element={
              <RoleRoute name='SociogramResultsDashboardPage'>
                <SociogramResultsDashboardPage />
              </RoleRoute>
            }
          />
          <Route
            path=':surveyId/results/:resultId/recommendations'
            element={
              <RoleRoute name='SurveyResultsRecommendationsPage'>
                <SurveyResultsRecommendationsPage />
              </RoleRoute>
            }
          />
          <Route
            path='start-survey'
            element={
              <RoleRoute name='SociogramSurveyPage'>
                <SociogramSurveyPage />
              </RoleRoute>
            }
          />
          <Route
            path='survey/:pageId/*'
            element={
              <RoleRoute name='SociogramPageById'>
                <SociogramPageById />
              </RoleRoute>
            }
          />
          <Route
            path='historic-sociogram/dashboard/:surveyId'
            element={
              <RoleRoute name='SociogramResultsDashboardPage'>
                <SociogramResultsDashboardPage />
              </RoleRoute>
            }
          />
          <Route
            path='historic-sociogram/*'
            element={
              <RoleRoute name='HistoricSociogramPage'>
                <HistoricSociogramPage />
              </RoleRoute>
            }
          />
          <Route
            path='*'
            element={<Navigate to='/' />}
          />
        </Routes>
      </DashboardSociogramContextProvider>
    </SociogramContextProvider>
  )
}

export default SociogramNavigation
